/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  createSlice,
  isPending,
  isRejected,
  SliceCaseReducers,
  ValidateSliceCaseReducers,
  ActionReducerMapBuilder,
  PayloadAction,
  AsyncThunk,
  // current,
  Slice
} from '@reduxjs/toolkit'
import {
  RequestErrorResponse,
  ErrorType,
  NetworkRequestError
} from '../../services/lib/'
import { formatError } from './errors'

export type NoInfer<T> = [T][T extends any ? 0 : never]

export interface GenericState<E> {
  ids: Array<string>
  entities: {
    [id: string]: E
  }
  loading: boolean
  error: NetworkRequestError | RequestErrorResponse | null
}

type AdapterFn<S> = (state: S | any, payload: PayloadAction | any) => S

interface ThunkAdapter<T> {
  adapterFn: AdapterFn<T>
  thunk: AsyncThunk<T, void, Record<string, unknown>>
}

export const createGenericSlice = <
  T,
  S extends GenericState<any>,
  Reducers extends SliceCaseReducers<S>
>({
  name,
  initialState,
  thunkAdapters,
  reducers,
  extraReducers
}: {
  name: string
  initialState: S
  thunkAdapters: Array<ThunkAdapter<T>>
  reducers?: ValidateSliceCaseReducers<S, Reducers>
  extraReducers?: (
    builder: ActionReducerMapBuilder<S>
  ) => ActionReducerMapBuilder<S>
}): Slice => {
  return createSlice({
    name,
    initialState,
    reducers: reducers || {},
    extraReducers: (builder) => {
      builder = thunkAdapters?.reduce((builder, item) => {
        return builder.addCase(item.thunk.fulfilled, (state, action) => {
          state.loading = false
          state.error = null

          if (action.payload !== null && action.payload !== undefined) {
            item.adapterFn(state, action.payload)
          }
        })
      }, builder)
      if (extraReducers) {
        builder = extraReducers(builder)
      }
      return builder
        ?.addMatcher(isPending, (state: GenericState<any>) => {
          state.loading = true
        })
        .addMatcher(
          isRejected,
          (
            //TODO: change 'any'
            state: any,
            action: any
          ) => {
            state.loading = false
            state.error = action.payload ? formatError(action.payload) : null
          }
        )
    }
  })
}
